import {getParentStructurePath} from '../../Common/PropertyPaths';

export const accidentFacilityCarePath = (planIndex: number = 0, coverageIndex: number = 0) => {
  const parentPath = getParentStructurePath(planIndex, coverageIndex);

  return {
    unitsOfAccidentFacilityCare: `${parentPath}.unitsOfAccidentFacilityCare`,

    isHospitalAdmissionApplied: `${parentPath}.isHospitalAdmissionApplied`,
    isHospitalConfinementApplied: `${parentPath}.isHospitalConfinementApplied`,
    isIntensiveCareUnitConfinementApplied: `${parentPath}.isIntensiveCareUnitConfinementApplied`,
    isStepDownIntensiveCareUnitConfinementApplied: `${parentPath}.isStepDownIntensiveCareUnitConfinementApplied`,
    isRehabilitationFacilityApplied: `${parentPath}.isRehabilitationFacilityApplied`,
    isObjectiveSecondOpinionApplied: `${parentPath}.isObjectiveSecondOpinionApplied`,

    hospitalAdmissionDetails: {
      incurralPeriod: `${parentPath}.hospitalAdmissionDetails.incurralPeriod`,
      customizeBenefitAmount: `${parentPath}.hospitalAdmissionDetails.customizeBenefitAmount`,
      benefitAmount: `${parentPath}.hospitalAdmissionDetails.benefitAmount.amount`,
      maxBenefitNumber: `${parentPath}.hospitalAdmissionDetails.maxBenefitNumber`,
      timePeriodCd: `${parentPath}.hospitalAdmissionDetails.timePeriodCd`,
    },

    hospitalConfinementDetails: {
      incurralPeriod: `${parentPath}.hospitalConfinementDetails.incurralPeriod`,
      customizeBenefitAmount: `${parentPath}.hospitalConfinementDetails.customizeBenefitAmount`,
      benefitAmount: `${parentPath}.hospitalConfinementDetails.benefitAmount.amount`,
      maxBenefitNumber: `${parentPath}.hospitalConfinementDetails.maxBenefitNumber`,
      timePeriodCd: `${parentPath}.hospitalConfinementDetails.timePeriodCd`,
    },

    intensiveCareUnitConfinementDetails: {
      incurralPeriod: `${parentPath}.intensiveCareUnitConfinementDetails.incurralPeriod`,
      customizeBenefitAmount: `${parentPath}.intensiveCareUnitConfinementDetails.customizeBenefitAmount`,
      benefitAmount: `${parentPath}.intensiveCareUnitConfinementDetails.benefitAmount.amount`,
      maxBenefitNumber: `${parentPath}.intensiveCareUnitConfinementDetails.maxBenefitNumber`,
      timePeriodCd: `${parentPath}.intensiveCareUnitConfinementDetails.timePeriodCd`,
    },

    stepDownIntensiveCareUnitConfinementDetails: {
      incurralPeriod: `${parentPath}.stepDownIntensiveCareUnitConfinementDetails.incurralPeriod`,
      customizeBenefitAmount: `${parentPath}.stepDownIntensiveCareUnitConfinementDetails.customizeBenefitAmount`,
      benefitAmount: `${parentPath}.stepDownIntensiveCareUnitConfinementDetails.benefitAmount.amount`,
      maxBenefitNumber: `${parentPath}.stepDownIntensiveCareUnitConfinementDetails.maxBenefitNumber`,
      timePeriodCd: `${parentPath}.stepDownIntensiveCareUnitConfinementDetails.timePeriodCd`,
      details: `${parentPath}.stepDownIntensiveCareUnitConfinementDetails`,
    },

    rehabilitationFacilityDetails: {
      incurralPeriod: `${parentPath}.rehabilitationFacilityDetails.incurralPeriod`,
      customizeBenefitAmount: `${parentPath}.rehabilitationFacilityDetails.customizeBenefitAmount`,
      benefitAmount: `${parentPath}.rehabilitationFacilityDetails.benefitAmount.amount`,
      maxBenefitNumber: `${parentPath}.rehabilitationFacilityDetails.maxBenefitNumber`,
      timePeriodCd: `${parentPath}.rehabilitationFacilityDetails.timePeriodCd`,
      maxBenefitNumber2: `${parentPath}.rehabilitationFacilityDetails.maxBenefitNumber2`,
      timePeriod2Cd: `${parentPath}.rehabilitationFacilityDetails.timePeriod2Cd`,
      details: `${parentPath}.rehabilitationFacilityDetails`,
    },

    objectiveSecondOpinionDetails: {
      incurralPeriod: `${parentPath}.objectiveSecondOpinionDetails.incurralPeriod`,
      customizeBenefitAmount: `${parentPath}.objectiveSecondOpinionDetails.customizeBenefitAmount`,
      benefitAmount: `${parentPath}.objectiveSecondOpinionDetails.benefitAmount.amount`,
      maxBenefitNumber: `${parentPath}.objectiveSecondOpinionDetails.maxBenefitNumber`,
      timePeriodCd: `${parentPath}.objectiveSecondOpinionDetails.timePeriodCd`,
    },
  };
};
